export const numberWithCommas = (x?: number) => {
  if (x === undefined || x === null) return;
  let [intPart, decPart] = x.toString().split(".");
  if (decPart) {
    decPart = decPart.slice(0, 2); // truncate, not round
  }

  // Add thousands separators to the integer part
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return combined
  return decPart !== undefined ? `${intPart}.${decPart}` : intPart;
};
